import * as styled from '../styles/final-cta-band';

type Props = {
  title: string;
  subtitle: string;
  ctaLabel: string;
  tone: 'green' | 'ink';
  onCtaClick: () => void;
};

export const FinalCtaBand = ({ title, subtitle, ctaLabel, tone, onCtaClick }: Props) => (
  <styled.Wrap>
    <styled.Title>{title}</styled.Title>
    <styled.Subtitle>{subtitle}</styled.Subtitle>
    <styled.Cta type="button" $tone={tone} onClick={onCtaClick}>
      {ctaLabel}
    </styled.Cta>
  </styled.Wrap>
);
